import React,{useEffect,useState} from "react";
import "./Gallery.css";
import Navber from "../../Components/Navber";
import ImageLightbox from "../../Components/Helping Component/ImageZoom.jsx";
import api from "../../Api.js";





export default function Gallery() {
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [currentImages, setCurrentImages] = useState([]);
    const [galleryData, setGalleryData] = useState([]);
useEffect(() => {
    const fetchGalleryData = async () => {
      try {
        const response = await api.get("/happy-customers");
        if (response.data.status) {
          // Assuming the API returns an array of image URLs
          const imagesFromApi = response.data.data;
          setGalleryData(imagesFromApi);
        }
      } catch (error) {
        console.error("Error fetching gallery data:", error);
      }
    };
    fetchGalleryData();
}, []);


    const handleGalleryOpen = (img) => {
      const galleryImages = galleryData?.[0]?.images?.map(item => item.url) || [];
      setCurrentImages([img?.url, ...galleryImages]);
      setLightboxOpen(true);
    };
  return (
    <>
      <Navber />
       <ImageLightbox
        open={lightboxOpen}
        setOpen={setLightboxOpen}
        images={currentImages}
      />
          <section className="joyraj-gallery-page">
      
      {/* IMAGE GALLERY */}
      <div className="joyraj-gallery-section">
        <h2>Photo Gallery</h2>

        <div className="joyraj-gallery-grid">
          {galleryData[0]?.images?.map((img, index) => (
            <div className="joyraj-gallery-card" key={index} onClick={() => handleGalleryOpen(img)}>
              <img src={img?.url} alt="Tour Gallery" />
            </div>
          ))}
        </div>
      </div>

      {/* VIDEO GALLERY */}
      <div className="joyraj-gallery-section">
        <h2>Video Gallery</h2>

        <div className="joyraj-gallery-grid joyraj-video-grid">
          {galleryData[0]?.videos?.map((video, index) => (
            <div className="joyraj-gallery-card joyraj-video-card" key={index}>
              <video src={video?.url} controls muted />
            </div>
          ))}
        </div>
      </div>

    </section>
</>
  );
}
